module.exports = __webpack_public_path__ + "img/4-1-2-3-preview-shoppingfiesta-E.02d3f9c9.jpg";